import { Spinner } from 'react-bootstrap';
import './Loader.scss';
import loader from '../../assets/images/loader.svg';
export const Loader = () => {
  return (
    <>
      <div className="loader-overlay"></div>
      <img src={loader} className="loader-img"></img>
      {/* <Spinner animation="border" variant="primary" className="main-loader" /> */}
    </>
  );
};
